import { useQuery } from '@tanstack/react-query';

import { getSeasons } from '@/infrastructure/network/data/season';
import { useOrganizationStore } from '@/store/organization-store';

export const useSeasonsOptionsQuery = (teamLeagueUuid: string, teamId?: string) => {
	const store = useOrganizationStore();
	return useQuery({
		queryKey: ['SEASONS', store.organizationUuid, teamLeagueUuid, teamId],
		queryFn: () => getSeasons({ teamLeagueUuid, organizationUuid: store.organizationUuid, teamId }),
		enabled: !!(store.organizationUuid && teamLeagueUuid)
	});
};
